import { Component, Input, OnInit } from '@angular/core';
import { Product } from '../../../../core/models';
import { TranslocoCurrencyPipe } from '@jsverse/transloco-locale';
import { PricePipe } from './../../../../core/pipes/price.pipe';

@Component({
    selector: 'app-combo-listing-item',
    standalone: true,
    imports: [TranslocoCurrencyPipe, PricePipe],
    templateUrl: './combo-listing-item.component.html',
    styleUrls: ['./combo-listing-item.component.css'],
})
export class GiftBoxComboListingItemComponent implements OnInit {

  @Input() product: Product

  constructor() { }

  ngOnInit(): void {
  }
  
}
